import { render, staticRenderFns } from "./SkeletonLoader.vue?vue&type=template&id=2e184ffa&"
import script from "./SkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./SkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB03-CV-02\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e184ffa')) {
      api.createRecord('2e184ffa', component.options)
    } else {
      api.reload('2e184ffa', component.options)
    }
    module.hot.accept("./SkeletonLoader.vue?vue&type=template&id=2e184ffa&", function () {
      api.rerender('2e184ffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/SkeletonLoader.vue"
export default component.exports